import $ from 'cash-dom';
import { grabOnInit } from '@core';

$(function () {
  grabOnInit();
})